import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { SkadenummerSporsmal } from '../reducer/sporsmalsflyt-types';
import { validateSkadenummer } from '../validation/validate';

export interface CurrentSkadenummerSporsmal {
    type: SporsmalType.Skadenummer;
    sporsmal: SkadenummerSporsmal;
    skadenummer?: string;
}

export interface BesvartSkadenummerSporsmal {
    type: SporsmalType.Skadenummer;
    sporsmal: SkadenummerSporsmal;
    skadenummer: string;
}

export const isSkadenummerSporsmal = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentSkadenummerSporsmal => currentSporsmal.type === SporsmalType.Skadenummer;

export const erGyldigSkadenummer = (currentSporsmal: CurrentSkadenummerSporsmal) =>
    validateSkadenummer(currentSporsmal.skadenummer);
